// src/components/HeroSection.jsx
import React from 'react';

export default function HeroSection() {
  return (
    <section className="w-full px-6 py-24 text-white bg-transparent">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="mb-6 text-5xl font-extrabold leading-tight tracking-tight sm:text-6xl">
          Give your agents real powers.
          <br />
          One API call at a time.
        </h1>

        <p className="max-w-xl mx-auto mb-8 text-lg text-gray-300">
          Instantly generate invoices, merge PDFs, and extract structured data from documents — all through
          clean, hosted endpoints built for developers and AI agents.
        </p>

        <a
          href="#subscribe"
          className="inline-block px-6 py-3 text-sm font-semibold text-white transition rounded-full bg-violet-600 hover:bg-violet-500"
        >
           Get Your Early Access Token →
        </a>
      </div>

      {/* Optional banner image */}
      {/* 
      <div className="flex justify-center mt-20">
        <img
          src="/banners/banner.png"
          alt="InvokeApi Example"
          className="w-[500px] rounded-xl shadow-lg"
        />
      </div> 
      */}
    </section>
  );
}
